<div class="alert-modal-overlay" *ngIf="isOpen" (click)="onOverlayClick($event)">
  <div class="alert-modal" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="alert-header">
      <h3 class="alert-title">{{ title }}</h3>
      <button type="button" *ngIf="showCloseIcon" class="close-btn" (click)="onClose()">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 4L4 12M4 4L12 12"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Divider -->
    <div class="alert-divider"></div>

    <!-- Content -->
    <div class="alert-content">
      <p class="alert-description">{{ description }}</p>
      <p class="alert-additional-description" *ngIf="additionalDescription">
        {{ additionalDescription }}
      </p>

      <!-- Warning Notice -->
      <div class="warning-notice" *ngIf="showWarning">
        <div class="warning-content">
          <div class="warning-icon">
            <img src="assets/images/red-warning.svg" alt="Warning" width="20" height="20" />
          </div>
          <div class="warning-text" *ngIf="warningMessage">
            <span>{{ warningMessage }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Actions (shared modal-footer) -->
    <app-modal-footer-actions
      footerClass="modal-footer"
      [showSecondary]="false"
      [showCancel]="!!secondaryButtonText"
      [cancelText]="secondaryButtonText"
      [primaryText]="primaryButtonText"
      [stackOnMobile]="true"
      (cancelClick)="onSecondaryAction()"
      (primaryClick)="onPrimaryAction()"
    />
  </div>
</div>
